import { PaymentProcessor } from './types';

export const getPaymentProcessors = (): PaymentProcessor[] =>
  // Replace this with a real datasource
  [{ name: 'PayPal', label: 'PayPal - PPGF' } as PaymentProcessor];
